import Entity from './entity'

export default class UserMenu extends Entity<number>{
    name:string;
    displayName:string;
    order:number;
    icon:string;
    url:string;
    target:string;
    isEnabled:boolean;
    isVisible:boolean;
    isNotCache:boolean;
    beforeCloseFunction:string;
    parentId?:number;
    parentDisplayName:string;
    isDeleted:boolean;
}